module.exports = __webpack_public_path__ + "static/media/ico_plus_o.aa9b91e5.svg";